import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import { CREATE_SHIFT, UPDATE_SHIFT } from "../../../Schema/Shift";

const useShiftForm = ({ handleClose, resetForm, setRefetch }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createShift] = useMutation(CREATE_SHIFT, {
    onCompleted: ({ createShift }) => {
      setLoading(false);

      if (createShift?.isSuccess === true) {
        setAlert(true, "success", createShift?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createShift?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateShift] = useMutation(UPDATE_SHIFT, {
    onCompleted: ({ updateShift }) => {
      setLoading(false);
      if (updateShift?.isSuccess === true) {
        setAlert(true, "success", updateShift?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateShift?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  return { updateShift, createShift, loading, setLoading };
};

export default useShiftForm;
